module.exports = __webpack_public_path__ + "img/video-control--play.c9f95b91.svg";